(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvSelectAll', drvSelectAll);

    drvSelectAll.$inject = [];

    /**
     * 'Select All' used throughout ChilliDocs
     * 
     * # Scope Properties
     * {array} items - Items which will be selected/deselected by the control
     *                 Objects in this array will have a {bool} 'Selected' property set.
     * {bool} selected - Is 'Select All' currently selected or not. This should be set to false when a list is refreshed
     * {bool} disabled - Is the control disabled
     */
    function drvSelectAll() {
        var directive = {
            link: link,
            restrict: 'E',
            scope: {},
            controller: function () {},
            controllerAs: 'drvCtrl',
            bindToController: {
                items: '=',
                selected: '=?',
                disabled: '<?'
            },
            template:
                '<span layout="row">' +
                '   <md-checkbox ng-disabled="drvCtrl.disabled" style="margin-bottom: 0px;" ng-model="drvCtrl.selected" aria-label="Select All"></md-checkbox>' +
                '   <span style="align-self: center;">{{drvCtrl.selectedItemsCount}} Selected</span>' +
                '</span>'
        };
        return directive;

        function link(scope, element, attrs) {
            Object.defineProperty(scope.drvCtrl, 'selectedItemsCount', {
                get: function () {
                    return _.filter(scope.drvCtrl.items, 'Selected').length;
                }
            });

            Object.defineProperty(scope.drvCtrl, 'selected', {
                get: function () {
                    return scope.drvCtrl.items && scope.drvCtrl.items.length > 0 && _.all(scope.drvCtrl.items, 'Selected');
                },
                set: function (selectedVal) {
                    _.forEach(scope.drvCtrl.items, function (item) {
                        item.Selected = selectedVal;
                    });
                }
            });
        }
    }
})();